import React from 'react'
import NumberFormat from 'react-number-format'

function toInputValue(value) {
  return value === null || value === undefined ? '' : String(value)
}

export default function InputNumeroInteiro({
  value,
  onChange,
  label = null,
  width = '100%',
  marginTop = 20,
  disabled = false,
  placeholder = null,
  format = null,
  id = undefined,
  allowNegative = true,
  decimalScale = undefined,
  isAllowed = undefined,
}) {
  const styles = {
    container: {
      textAlign: 'left',
      marginTop,
    },
    label: {
      fontSize: '0.8rem',
      color: '#14B0BF',
      display: 'block',
    },
    input: {
      width,
      outline: 'none',
      border: '1px solid  #F1F1F1',
      height: 30,
      marginTop: 3,
      backgroundColor: disabled ? 'rgba(239, 239, 239, 0.3)' : 'rgba(255, 255, 255, 0.9)',
      padding: 10,
    },
  }

  return (
    <div style={styles.container}>
      {label ? (
        <label style={styles.label} htmlFor="myInput">
          {label}
        </label>
      ) : null}
      <NumberFormat
        id={id}
        placeholder={placeholder}
        disabled={disabled}
        style={styles.input}
        isNumericString={true}
        format={format}
        allowNegative={allowNegative}
        decimalScale={decimalScale}
        isAllowed={isAllowed}
        value={value}
        onValueChange={({ value: nextValue }) => {
          if (onChange && nextValue !== toInputValue(value)) onChange(nextValue)
        }}
      />
    </div>
  )
}
